import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollToTopProps {
  smooth?: boolean;
  delay?: number;
}

const ScrollToTop: React.FC<ScrollToTopProps> = ({ 
  smooth = true, 
  delay = 0 
}) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Hash varsa (örn: #section) o element'e scroll et
    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({
            behavior: smooth ? 'smooth' : 'auto',
            block: 'start',
          });
        }
      }, delay + 100); // Hash scroll için biraz daha bekle
      return;
    }

    // Hash yoksa sayfa başına scroll et
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: smooth ? 'smooth' : 'auto'
      });
    };

    // Delay varsa bekle, yoksa hemen scroll et
    if (delay > 0) {
      const timeoutId = setTimeout(scrollToTop, delay);
      return () => clearTimeout(timeoutId);
    } else {
      scrollToTop();
    }
  }, [pathname, hash, smooth, delay]);

  return null; // Bu component render etmez
};

export default ScrollToTop; 